import { getApis } from 'library/Apis';
import api from 'services/api';

const getEndpoint = () => {
  return getApis().apis.backofficeProjetos + 'v2/escola/cadastro-pendente';
};

export const hasCadastroPendente = async () => {
  try {
    const response = await api.get(getEndpoint());
    return response.data.cadstroPendente;
  } catch (error) {
    console.error('Erro ao verificar cadastro pendente:', error);
    return false;
  }
};
